export enum TimeZoneDisplay {
  Local = "Local",
  Source = "Source",
  UTC = "UTC"
}